export const PROTOCOLS = [
  { label: 'TCP', value: 'TCP' },
  { label: 'UDP', value: 'UDP' },
  { label: 'SCTP', value: 'SCTP' },
];

export const ACCESS_MODES = [
  { label: 'NodePort', value: 'NodePort' },
  // { label: 'LoadBalancer', value: 'LoadBalancer' },
];

export const VOLUME_ACCESS_MODES = ['ReadWriteOnce', 'ReadOnlyMany', 'ReadWriteMany'];
